import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { getPrimaryImage } from '../../services/imageService';
import Image from '../common/Image';
import './CartItem.css';

const CartItem = ({ item }) => {
  const { updateCartItem, removeFromCart } = useCart();
  const primaryImage = getPrimaryImage(item.product.images);

  const decreaseQuantity = async () => {
    if (item.quantity > 1) {
      await updateCartItem(item.id, item.quantity - 1);
    } else {
      if (window.confirm('Remove this item from cart?')) {
        await removeFromCart(item.id);
      }
    }
  };

  const increaseQuantity = async () => {
    await updateCartItem(item.id, item.quantity + 1);
  };

  return (
    <div className="cart-item">
      <div className="cart-item-image-container">
        <Link to={`/products/${item.product.slug}`}>
          <Image 
            src={primaryImage?.image_url} 
            alt={item.product.name}
            fallback="/placeholder-watch.jpg"
          />
        </Link>
      </div>

      <div className="cart-item-details">
        <Link to={`/products/${item.product.slug}`} className="cart-item-name">
          {item.product.name}
        </Link>
        {item.color && (
          <p className="cart-item-variant">
            <span
              className="cart-item-color-swatch"
              style={{ backgroundColor: item.color.hex_code }}
              aria-hidden="true"
            />
            {item.color.name}
          </p>
        )}
      </div>

      <div className="cart-item-actions">
        <div className="quantity-controls">
          <button onClick={decreaseQuantity} className="qty-btn" aria-label="Decrease quantity">-</button>
          <span className="qty-value">{item.quantity}</span>
          <button onClick={increaseQuantity} className="qty-btn" aria-label="Increase quantity">+</button>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
